var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InformationItem',_vm._b({attrs:{"compact":"true"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Phones")]},proxy:true}])},'InformationItem',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }